import React from 'react'
import { Container } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
   
    <div className='bg-white mt-3 border-top'>
       <Container>
         <div className="col-md-12 bg-light pb-2 pt-2">
        <div className="row m-0" >
          <div className="col-lg-4 ">
            <p className="small mb-4 mb-lg-0 pt-2">Copyrights © 2025 AIPharmaExchange.com. All rights reserved.</p>
          </div>
          <div className="col-lg-8 d-flex justify-content-end">
            <p className="small mb-4 mb-lg-0 pl-4">
            <Nav
      activeKey="/home"
      onSelect={(selectedKey) => alert(`selected ${selectedKey}`)}
    >
      
      <Nav.Item>
        <Nav.Link as={Link} to="/" className='text-dark'>Terms of Use   </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link as={Link} to="/"className='text-dark'>Privacy Policy  </Nav.Link>
      </Nav.Item>
    </Nav>
            </p>
          </div>
          </div>
      </div>
      </Container>
    </div>
   
  )
}

export default Footer